import React from 'react'
import { FaChartLine, FaShieldAlt, FaNetworkWired, FaMicrochip, FaMobileAlt, FaShoppingCart } from 'react-icons/fa'

export const projectsData = [
    {
        id: 1,
        projectName: 'Site Reliability, Infrastructure & Observability',
        company: 'hokify',
        projectDesc:
            'Work extensively on site reliability for production systems at hokify, alongside AWS infrastructure and GitHub Actions CI/CD. Build observability with Grafana dashboards and managed OpenSearch log pipelines, and develop incident-response workflows and security procedures.',
        tags: ['Site Reliability', 'AWS', 'GitHub Actions', 'OpenSearch', 'Grafana', 'Security'],
        icon: <FaChartLine />,
    },
    {
        id: 2,
        projectName: 'NIS2-Aligned AWS Security Hardening',
        company: 'Eversports',
        projectDesc:
            'Strengthened AWS security posture for NIS2 compliance across a multi-account TypeScript CDK monorepo, fixed multi-pipeline CircleCI deployment issues, and automated infrastructure diagrams straight from CloudFormation stacks.',
        tags: ['AWS CDK', 'CircleCI', 'CloudFormation', 'IAM', 'NIS2'],
        icon: <FaShieldAlt />,
    },
    {
        id: 3,
        projectName: 'GCP → AWS Kubernetes Migration',
        company: 'Viora',
        projectDesc:
            'Migrated a production Kubernetes back-end from GCP to AWS and decomposed a monolithic service into microservices, backed by a CDN-based edge architecture and custom VM images for multiple codebases.',
        tags: ['Kubernetes', 'AWS', 'GCP', 'Microservices'],
        icon: <FaNetworkWired />,
    },
    {
        id: 4,
        projectName: 'IoT Fleet & Cloud Infrastructure at Scale',
        company: 'Saveeye',
        projectDesc:
            'Managed an MQTT/ThingsBoard IoT device fleet, led the move from Kubernetes to AWS ECS to cut cost while keeping availability high, and built firmware CI/CD pipelines with CodeBuild and S3 versioning.',
        tags: ['AWS ECS', 'MQTT', 'ThingsBoard', 'PostgreSQL', 'WAF'],
        icon: <FaMicrochip />,
    },
    {
        id: 5,
        projectName: 'Net Shield — Ad Blocker',
        company: 'Personal project',
        projectDesc:
            'A system-wide ad blocker for mobile that works across any app or browser without root access or a special browser — built end-to-end from backend to app.',
        tags: ['Flutter', 'Dart', 'PHP'],
        demo: 'https://netshield.ir/',
        icon: <FaMobileAlt />,
    },
    {
        id: 6,
        projectName: 'E-Commerce Platform & CI/CD Pipeline',
        company: 'UGA',
        projectDesc:
            'Designed and shipped an e-commerce platform end-to-end: AWS backend, Dockerized deployment on ECS, a Jenkins CI/CD pipeline, and a custom PHP CMS.',
        tags: ['Docker', 'Jenkins', 'AWS ECS', 'PHP'],
        icon: <FaShoppingCart />,
    },
]
